import {useSelector} from "react-redux";
import appstrore_en from '../images/appstrore-en.svg';
import google_play_en from '../images/google-play-en.svg';
import appstrore_ru from '../images/appstrore-ru.svg';
import google_play_ru from '../images/google-play-ru.svg';
import fb from '../images/fb.svg'
import tw from '../images/tw.svg'
import yt from '../images/yt.svg'
import s_in from '../images/in.svg'
import tg from '../images/tg.svg'
import vk from '../images/vk.svg'
import logo from "../images/logo.svg";
import React from "react";

export const Footer = () => {
    const translate = useSelector(state => state.app.translate)
    const airconfig = useSelector(state => state.app.airconfig)
    const app_lang = useSelector(state => state.app.app_lang)
    if (app_lang === 'en') {

    }
    return (
        <footer className="footer">
            <div className="container">
                <div className="container__wrap footer__flex">
                    <nav className="footer__menu footer__menu_1">
                        <div className="footer__heading">
                            {translate.footer_col_1}
                        </div>
                        <ul>
                            {

                                airconfig.map((item) => {
                                    if (item.fields.type === 'footer_menu_col_1' && item.fields.locale === app_lang) {
                                        return (
                                            <li key={item.fields.id}>
                                                <a href={item.fields.link} target="_blank" rel="noopener">
                                                    {item.fields.label}
                                                </a>
                                            </li>
                                        )
                                    }
                                    return null;
                                })
                            }
                        </ul>
                    </nav>
                    <nav className="footer__menu footer__menu_2">
                        <div className="footer__heading">
                            {translate.footer_col_2}
                        </div>
                        <ul>
                            {

                                airconfig.map((item) => {
                                    if (item.fields.type === 'footer_menu_col_2' && item.fields.locale === app_lang) {
                                        return (
                                            <li key={item.fields.id}>
                                                <a href={item.fields.link} target="_blank" rel="noopener">
                                                    {item.fields.label}
                                                </a>
                                            </li>
                                        )
                                    }
                                    return null;
                                })
                            }
                        </ul>
                    </nav>
                    <nav className="footer__menu footer__menu_3">
                        <div className="footer__heading">
                            {translate.footer_col_3}
                        </div>
                        <ul>
                            {

                                airconfig.map((item) => {
                                    if (item.fields.type === 'footer_menu_col_3' && item.fields.locale === app_lang) {
                                        return (
                                            <li key={item.fields.id}>
                                                <a href={item.fields.link} target="_blank" rel="noopener">
                                                    {item.fields.label}
                                                </a>
                                            </li>
                                        )
                                    }
                                    return null;
                                })
                            }
                        </ul>
                    </nav>
                    <nav className="footer__menu footer__menu_4">
                        <div className="footer__heading">
                            {translate.footer_col_4}
                        </div>
                        <ul>
                            {

                                airconfig.map((item) => {
                                    if (item.fields.type === 'footer_menu_col_4' && item.fields.locale === app_lang) {
                                        return (
                                            <li key={item.fields.id}>
                                                <a href={item.fields.link} target="_blank" rel="noopener">
                                                    {item.fields.label}
                                                </a>
                                            </li>
                                        )
                                    }
                                    return null;
                                })
                            }
                        </ul>
                    </nav>
                    <div className="footer__apps">
                        <div className="footer__heading">
                            {translate.footer_col_5}
                        </div>
                        <div className="footer__apps_links">
                            {
                                airconfig.map((item) => {
                                    if (item.fields.id === 'footer_appstrore' && item.fields.locale === app_lang) {
                                        return (
                                            <a href={item.fields.link} key={item.fields.id} target="_blank"
                                               rel="noopener">
                                                {
                                                    app_lang === 'en' && (
                                                        <img src={appstrore_en} alt={item.fields.label}
                                                             title={item.fields.label}/>)
                                                }
                                                {
                                                    app_lang === 'ru' && (
                                                        <img src={appstrore_ru} alt={item.fields.label}
                                                             title={item.fields.label}/>)
                                                }
                                            </a>
                                        )
                                    }
                                    return null;
                                })
                            }
                            {
                                airconfig.map((item) => {
                                    if (item.fields.id === 'footer_google_play' && item.fields.locale === app_lang) {
                                        return (
                                            <a href={item.fields.link} key={item.fields.id} target="_blank"
                                               rel="noopener">
                                                {
                                                    app_lang === 'en' && (
                                                        <img src={google_play_en} alt={item.fields.label}
                                                             title={item.fields.label}/>)
                                                }
                                                {
                                                    app_lang === 'ru' && (
                                                        <img src={google_play_ru} alt={item.fields.label}
                                                             title={item.fields.label}/>)
                                                }
                                            </a>
                                        )
                                    }
                                    return null;
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="container__wrap footer__flex_2">
                    {
                        airconfig.map((item) => {
                            if (item.fields.id === 'logo' && item.fields.locale === app_lang) {
                                return (
                                    <a href={item.fields.link} key={item.fields.id} className="footer__logo"
                                       target="_blank" rel="noopener">
                                        <img src={logo} alt={item.fields.label} title={item.fields.label}/>
                                    </a>
                                )
                            }
                            return null;
                        })
                    }

                    <div className="footer__social">
                        {

                            airconfig.map((item) => {
                                if (item.fields.type === 'footer_soc' && item.fields.locale === app_lang) {
                                    return (
                                        <a href={item.fields.link} key={item.fields.id} target="_blank"
                                           rel="noopener">
                                            {item.fields.label === 'fb' &&
                                            <span className="fb" style={{maskImage: `url(${fb})`, WebkitMaskImage: `url(${fb})`}}/>}
                                            {item.fields.label === 'tw' &&
                                            <span className="tw" style={{maskImage: `url(${tw})`, WebkitMaskImage: `url(${tw})`}}/>}
                                            {item.fields.label === 'yt' &&
                                            <span className="yt" style={{maskImage: `url(${yt})`, WebkitMaskImage: `url(${yt})`}}/>}
                                            {item.fields.label === 'in' &&
                                            <span className="in" style={{maskImage: `url(${s_in})`, WebkitMaskImage: `url(${s_in})`}}/>}
                                            {item.fields.label === 'tg' &&
                                            <span className="tg" style={{maskImage: `url(${tg})`, WebkitMaskImage: `url(${tg})`}}/>}
                                            {item.fields.label === 'vk' &&
                                            <span className="vk" style={{maskImage: `url(${vk})`, WebkitMaskImage: `url(${vk})`}}/>}
                                        </a>
                                    )
                                }
                                return null;
                            })
                        }
                    </div>
                    {
                        airconfig.map((item) => {
                            if (item.fields.id === 'footer_copyright' && item.fields.locale === app_lang) {
                                return (
                                    <div key={item.fields.id} className="footer__copyright">
                                        {item.fields.label}
                                    </div>
                                )
                            }
                            return null;
                        })
                    }
                </div>

            </div>
        </footer>

    )
}